import {
  useEffect,
  useState,
  useRef,
  useMemo,
  createContext,
  useContext,
} from "react";
import SliderBarMaps from "../../../../componentes/easyMaps/sideBarEasyMaps";
import api from "../../../../services/api";
import {
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import "../../../../componentes/leaflet-migrations";
import "../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import LeafletMapa from "./leaflatMapa";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { ReactComponent as BarIcon } from "../../../../assets/easyMaps/titlebar.svg";
import LoadingUpdate from "../../../../componentes/easyMaps/loadingUpdate";
import getCentroid from "../utils/getCentroid";
import { MapaContext } from "../../../../contexts/mapaContext";
import { toast, ToastContainer } from "react-toastify";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import alertSoundFile from "../../../../assets/sounds/new-notification.mp3";
import zIndex from "@mui/material/styles/zIndex";
export default function MapaGeolocalizado({ socketCliente }) {
  const tipo = "easymon";
  const mapRef = useRef();
  const theme = useTheme();
  const [snackbar, setSnackbar] = useState(null);
  const [produtos, setProdutos] = useState(false);
  const [map, setMap] = useState(null);
  const [configurationMap, setConfigurationMap] = useState(null);
  const [elements, setElements] = useState(new Map());
  const [elementSelected, setElementSelected] = useState(null);
  const [connectionSelected, setConnectionSelected] = useState(null);
  const [connections, setConnections] = useState(new Map());
  const [fullScreem, setFullScreem] = useState(false);
  const [mapas, setMapas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [iconsElements, setIconsElements] = useState([]);
  const [loadingMap, setLoadingMap] = useState(true);
  const [sinc, setSinc] = useState(false);
  const [checkChanges, setCheckChanges] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [lastCollectData, setLastCollectData] = useState(null);
  const [rulerMode, setRulerMode] = useState(false);
  const [soundState, setSoundState] = useState(false);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState(new Map());
  const [newAlerts, setNewAlerts] = useState([]);
  const [connectionsDataMap, setConnectionsDataMap] = useState(new Map());
  const [
    connectionsDataMapPercentTraffic,
    setConnectionsDataMapPercentTraffic,
  ] = useState(new Map());
  const [connectionsDataMapPercentPower, setConnectionsDataMapPercentPower] =
    useState(new Map());

  const [configElementDataMap, setConfigElementDataMap] = useState(new Map());
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const { id } = useParams();
  const navigate = useNavigate();
  const editmodeRef = useRef();
  const { config, configLayer, setConfigLayer, setElementSelectedBool } =
    useOutletContext();
  const startMapRef = useRef(false);

  const latLngZoomFromUrl = useMemo(() => {
    const url = new URL(window.location.href);
    const latURL = url.searchParams.get("lat");
    const lngURL = url.searchParams.get("lng");
    const zoomURL = url.searchParams.get("zoom");

    const lat = latURL ? Number(latURL) : NaN;
    const lng = lngURL ? Number(lngURL) : NaN;
    const zoom = zoomURL ? Number(zoomURL) : NaN;

    return { lat, lng, zoom };
  }, []);

  const isMobile =
    navigator.userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1300,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
      backgroundColor: theme.palette.background.default,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.mode != "dark" ? "#e0e0e093" : "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    editMode: {
      position: "absolute",
      zIndex: 1203,
      fontSize: "13px",
      border:
        (fullScreem ? "4px" : "2px") + " solid " + theme.palette.secondary.main,
      display: "flex",
      alignItems: "stop",
      justifyContent: "center",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      //boxShadow: "inset 0px 0px 10px 0px " + theme.palette.color.alerts.info,
    },
    dotEditMode: {
      mt: "-2px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "fit-content",
    },
    textEditMode: {
      mt: "-27px",
      color: "white",
      fontSize: "15px",
      width: "fit-content",
    },
    toastContainer: {
      zIndex: fullScreem ? 1301 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: (id) => {
          mapRef?.current?.focusZoomExt(id);
        },
        element,
        theme,
        sound: index === 0 && soundState, // Toca o som apenas para o primeiro alerta da lista
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  //atualiza a varivel para container do toast
  useEffect(() => {
    if (!setElementSelectedBool) return;
    setElementSelectedBool(elementSelected != null);
  }, [elementSelected]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (config) {
      updateDataElementSocket();
    }
  }, [config]);

  useEffect(() => {
    editmodeRef.current = editMode;
    if (!editMode) {
      updateDataElementSocket();
    }
  }, [editMode]);

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;
    setElementSelected({
      ...elements?.get(elementSelected.id),
    });
  }, [elements]);

  useEffect(() => {
    if (connectionSelected == null || checkChanges) return;
    setConnectionSelected({
      ...connections?.get(connectionSelected.id),
    });
  }, [connections]);

  useEffect(() => {
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((configLayer) => ({
        ...configLayer,
        [id]: "trafego",
      }));
    }
    let timeInterval = config?.configuracoes?.geo?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);

    return () => window.clearInterval(interval);
  }, [id, config]);

  useEffect(() => {
    if (!id || !config) return;
    setLoadingMap(true);
    inicializeMap();
    getIconDB();
    handleApiGetProdutos(tipo);
    handleApiGetMaps();
  }, [id, config]);

  async function inicializeMap() {
    await Promise.all([handleApiGetMap(id), handleApiGetElements(id)]);
    setLoadingMap(false);
    startMapRef.current = true;
  }
  async function handleApiGetMap(id) {
    try {
      const response = await api.post("/easyMaps/map/findMapById", {
        mapId: id,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        if (response.data.tipo != 0) navigate("/easyMaps");
        else {
          const { ConfigMapEasyMaps, ...map } = response.data;
          setMap(map);
          if (ConfigMapEasyMaps) {
            setConfigurationMap(ConfigMapEasyMaps);
          } else {
            //usa a configurações globais
            setConfigurationMap({
              configuracoes: config?.configuracoes?.geo || null,
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetElements(id) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/easyMaps/element/findMany", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;
        // transforma os elements em MAP
        let elements = new Map(data.responseAlerts.map((el) => [el.id, el]));
        let connections = new Map(data.connections.map((el) => [el.id, el]));

        setElements(elements);
        setConnections(connections);
        updateDataElementSocket();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function updateDataElementSocket() {
    if (editmodeRef.current) return;
    try {
      setSinc(true);
      socketCliente.emit("getDataElementsMap", { mapId: id }, (response) => {
        setSinc(false);
        setNewAlerts([]);
        if (response.status !== 200) {
          setSnackbar({
            children: "Error: Não foi possível atualizar os elementos",
            severity: "error",
          });
        } else {
          // trnsforma os elements em MAP
          const updatedData = response?.data;
          const newHostsMap = new Map();
          const newAlertsMap = new Map();
          const newConnectionsMap = new Map();
          const configElementMap = new Map();
          let connGroupedByPercentegeTrafego = {};
          let connGroupedByPercentegePotencia = {};

          for (const el of updatedData.elementosResponse) {
            // hosts por elemento
            if (el.hosts?.length) {
              newHostsMap.set(el.id, el.hosts);
            }

            // conexões concatenadas

            for (const conn of el.connections) {
              //trafego

              if (conn?.corTraffic?.label in connGroupedByPercentegeTrafego) {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label] = [
                  conn.id,
                ];
              }
              //potencia
              if (conn?.corPower?.label in connGroupedByPercentegePotencia) {
                connGroupedByPercentegePotencia[conn?.corPower?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegePotencia[conn?.corPower?.label] = [
                  conn.id,
                ];
              }

              newConnectionsMap.set(conn.id, conn);
            }

            // alerts por elemento (ou por host, se preferir)
            if (el.alerts?.length) {
              newAlertsMap.set(el.id, el.alerts);

              // somente os novos
              const newAlerts = el.alerts.filter((alert) => alert.isNew);

              if (newAlerts.length > 0) {
                setNewAlerts((prev) => {
                  const existingKeys = new Set(
                    prev.map((a) => `${a.triggerid}-${a.eventid}`),
                  );

                  const filtered = newAlerts.filter(
                    (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                  );

                  return [...prev, ...filtered];
                });
              }
            }
            configElementMap.set(el.id, el.config);
          }
          setHostsDataMap(newHostsMap);
          setConfigElementDataMap(configElementMap);
          setAlertsDataMap(newAlertsMap);
          setConnectionsDataMap(newConnectionsMap);
          setLastCollectData(updatedData?.dataColeta || null);

          // conexões agrupadas por percentual
          setConnectionsDataMapPercentTraffic(
            new Map(Object.entries(connGroupedByPercentegeTrafego)),
          );
          setConnectionsDataMapPercentPower(
            new Map(Object.entries(connGroupedByPercentegePotencia)),
          );
        }
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível atualizar",
        severity: "error",
      });
    }
  }

  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map) => ({
              nome: map.titulo,
              id: map.id,
              tipo: map.tipo,
            })),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetProdutos(tipo) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/cliente/produto/findMany", {
        tipo,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar Clientes",
          severity: "error",
        });
      } else {
        setProdutos(response.data);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function getIconDB() {
    try {
      const response = await api.get("/easyMaps/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  const coordinates = useMemo(() => {
    return [...elements.values()]?.map(
      (el) => el?.elementConfig?.config?.coordenadas,
    );
  }, [elements]);
  const onImportComplete = async () => {
    setLoadingMap(true);
    await handleApiGetElements(id);
    setLoadingMap(false);
  };

  const boundsCoordinates = useMemo(() => {
    if (coordinates.length > 0) {
      return coordinates.map((c) => [Number(c.lat), Number(c.long)]);
    }
    return [[-6.716659784392299, -47.988281250000014]];
  }, [coordinates]);

  const centerCoordinates = useMemo(() => {
    if (
      latLngZoomFromUrl.lat &&
      latLngZoomFromUrl.lng &&
      isNaN(latLngZoomFromUrl?.lat) == false &&
      isNaN(latLngZoomFromUrl?.lng) == false
    )
      return [Number(latLngZoomFromUrl.lat), Number(latLngZoomFromUrl.lng)];
    return [-10, -48];
  }, [coordinates]);

  return (
    //Atenção: O contexto MapaContext é usado para compartilhar o estado do mapa e elementos entre os componentes filhos,
    // nas proximas atualizações usem essa forma para organizar o acesso aos dados do mapa.
    // Isso facilita a manutenção e a escalabilidade do código.
    // e Se possivel, removam os props desnecessários dos componentes filhos.
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "geo",
        elements,
        setElements,
        elementSelected,
        setElementSelected,
        connections,
        setConnections,
        connectionSelected,
        setConnectionSelected,
        editMode,
        setEditMode,
        checkChanges,
        setCheckChanges,
        snackbar,
        setSnackbar,
        updateDataElementSocket,
        configurationMap,
        setConfigurationMap,
        mapRef,
        hostsDataMap,
        alertsDataMap,
        configElementDataMap,
        connectionsDataMap,
        lastCollectData,
        connectionsDataMapPercentTraffic,
        connectionsDataMapPercentPower,
        rulerMode,
        setRulerMode,
        startMapRef,
        soundState,
        setSoundState,
      }}
    >
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMaps
            iconsElements={iconsElements}
            collapse={collapse}
            //setFocusNodeId={setFocusNodeId}
            handleCollapse={handleCollapse}
            fullScreem={fullScreem}
          />
        )}

        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {editMode && (
            <Box sx={styles.editMode}>
              <Box sx={styles.dotEditMode}>
                <BarIcon width={"250px"} fill={theme.palette.secondary.main} />
                <Typography sx={styles.textEditMode}>Modo de Edição</Typography>
              </Box>
            </Box>
          )}

          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" disableShrink />
              <Typography
                fontSize="14px"
                color={theme.palette.color.textEasyMaps}
              >
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
            rulerMode={rulerMode}
          />

          <LeafletMapa
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            socketCliente={socketCliente}
            ref={mapRef}
            iconsElements={iconsElements}
            setIconsElement={setIconsElements}
            title={map?.titulo}
            element={editMode ? elementSelected : null}
            produtos={produtos}
            api={api}
            setSnackbar={setSnackbar}
            mapas={mapas}
            setMapas={setMapas}
            centerCoordinates={centerCoordinates}
            f
            boundsCoordinates={boundsCoordinates}
            onImportComplete={onImportComplete}
            collapse={collapse}
            latLngZoomFromUrl={latLngZoomFromUrl}
          />
        </Stack>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transitionDuration={1}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </MapaContext.Provider>
  );
}
